<ng-container *ngIf="{ entries: quickAccessEntries$ | async, title: quickAccessTitle$ | async } as data">
	<div class="grid">
		<div class="col-12 mb-4">
			<mat-card class="mat-elevation-z0 px-5 pb-3 h-full flex flex-col">
				<mat-card-title class="flex justify-content-between mt-1">
					<div class="text-xl font-bold">{{ 'sidebar.quickAccess' | translate }}</div>
				</mat-card-title>
				<mat-card-content>
					<p class="text-muted mb-3">
						{{ 'txQuickAccess.description' | translate }}
					</p>

					<!-- Title Configuration -->
					<div class="mb-4 pb-3 border-bottom-1">
						<div *ngIf="!editingTitle" class="display-flex flex-align-items-center">
							<strong class="mr-2">{{ 'txQuickAccess.quickAccessLabel' | translate }}:</strong>
							<span class="mr-2">{{ data.title || ('txBuchungen.quickAccess' | translate) }}</span>
							<button mat-icon-button (click)="startEditingTitle(data.title)" [matTooltip]="'txQuickAccess.changeLabel' | translate">
								<fa-icon icon="pencil-alt"></fa-icon>
							</button>
						</div>
						<div *ngIf="editingTitle" class="display-flex flex-align-items-center">
							<mat-form-field appearance="outline" class="flex-grow-1 mr-2">
								<mat-label>{{ 'txQuickAccess.quickAccessLabel' | translate }}</mat-label>
								<input matInput [(ngModel)]="editedTitle" maxlength="50" placeholder="{{ 'txQuickAccess.titlePlaceholder' | translate }}" />
							</mat-form-field>
							<button mat-mini-fab class="mr-1" (click)="saveTitle()">
								<fa-icon icon="save"></fa-icon>
							</button>
							<button mat-mini-fab color="primary" (click)="cancelEditingTitle()">
								<fa-icon icon="times-circle"></fa-icon>
							</button>
						</div>
					</div>

					<!-- List of existing entries -->
					<div class="display-flex flex-direction-column" cdkDropList (cdkDropListDropped)="onDrop($event, data.entries)">
						<div class="quick-access-entry mb-3 p-3 border-1 rounded" *ngFor="let entry of data.entries" cdkDrag [cdkDragDisabled]="EditMode[entry.id]">
							<!-- Edit Mode -->
							<div *ngIf="EditMode[entry.id]" class="display-flex flex-direction-column">
								<div class="mat-dense-input display-flex flex-grow-1 mb-2">
									<mat-form-field appearance="standard" class="flex-grow-1">
										<mat-label>{{ 'txQuickAccess.label' | translate }}</mat-label>
										<input matInput [(ngModel)]="getEdited(entry).bezeichnung" maxlength="25" />
									</mat-form-field>
								</div>
								<div class="mat-dense-input display-flex mb-2">
									<mat-form-field appearance="standard" class="flex-grow-1 mr-1">
										<mat-label>{{ 'txQuickAccess.order' | translate }}</mat-label>
										<mat-select
											[(ngModel)]="getEdited(entry).auftragsnummer"
											(selectionChange)="onAuftragChange(entry)"
											(openedChange)="$event && initSearchControlForEntry(entry.id)">
											<mat-option>
												<ngx-mat-select-search 
													[formControl]="searchControlAuftragEdit[entry.id]" 
													(keyup)="onSearchAuftragEdit(entry.id, $event)"
													[placeholderLabel]="'general.search' | translate"
													[noEntriesFoundLabel]="'general.noOptionsFound' | translate">
												</ngx-mat-select-search>
											</mat-option>
											<mat-option *ngFor="let auftrag of filteredAuftragsArrayEdit[entry.id] || auftragsArray" [value]="auftrag.auftragsnummer">
												{{ auftrag.bezeichnung }} ({{ auftrag.auftragsnummer }})
											</mat-option>
										</mat-select>
									</mat-form-field>
									<mat-form-field appearance="standard" class="flex-grow-1">
										<mat-label>{{ 'txQuickAccess.task' | translate }}</mat-label>
										<mat-select
											[(ngModel)]="getEdited(entry).schrittnummer"
											(selectionChange)="onSchrittChange(entry)"
											(openedChange)="$event && initSearchControlForEntry(entry.id)">
											<mat-option>
												<ngx-mat-select-search 
													[formControl]="searchControlSchrittEdit[entry.id]"
													(keyup)="onSearchSchrittEdit(entry.id, $event, getAuftragsschritteForEntry(entry))"
													[placeholderLabel]="'general.search' | translate"
													[noEntriesFoundLabel]="'general.noOptionsFound' | translate">
												</ngx-mat-select-search>
											</mat-option>
											<mat-option
												*ngFor="let schritt of getFilteredSchritteForEntry(entry)"
												[value]="schritt.schrittnummer">
												{{ schritt.schrittbezeichnung }}
											</mat-option>
										</mat-select>
									</mat-form-field>
								</div>
								<div class="display-flex flex-justify-content-flex-end">
									<button mat-mini-fab class="mr-1" (click)="onSave(entry)">
										<fa-icon icon="save"></fa-icon>
									</button>
									<button mat-mini-fab color="primary" (click)="onDiscard(entry)">
										<fa-icon icon="times-circle"></fa-icon>
									</button>
								</div>
							</div>

							<!-- View Mode -->
							<div *ngIf="!EditMode[entry.id]" class="display-flex flex-align-items-center">
								<!-- Drag Handle -->
								<div class="drag-handle mr-3" cdkDragHandle>
									<fa-icon icon="grip-vertical" class="text-muted"></fa-icon>
								</div>
								<div class="flex-grow-1 display-flex flex-justify-content-space-between flex-align-items-center">
									<div class="flex-grow-1">
										<div class="mat-h3 m-0 mb-1">
											<strong>{{ entry.bezeichnung }}</strong>
										</div>
										<div class="text-sm text-muted">
											<span class="mr-3">
												<strong>{{ 'txQuickAccess.order' | translate }}:</strong> {{ entry.auftragsbezeichnung }} ({{ entry.auftragsnummer }})
											</span>
											<span>
												<strong>{{ 'txQuickAccess.task' | translate }}:</strong> {{ entry.schrittbezeichnung }}
											</span>
										</div>
									</div>
									<div class="display-flex flex-align-items-center">
										<button mat-mini-fab class="mr-1" (click)="EditMode[entry.id] = true; initSearchControlForEntry(entry.id)">
											<fa-icon icon="pencil-alt"></fa-icon>
										</button>
										<button mat-mini-fab color="primary" (click)="deleteEntry(entry)">
											<fa-icon icon="trash"></fa-icon>
										</button>
									</div>
								</div>
							</div>
						</div>

						<!-- Empty state -->
						<div *ngIf="!data.entries || data.entries.length === 0" class="text-center py-5">
							<fa-icon icon="inbox" size="3x" class="text-muted mb-3"></fa-icon>
							<p class="text-muted">
								{{ 'txQuickAccess.noEntries' | translate }}<br />
								{{ 'txQuickAccess.createNewBelow' | translate }}
							</p>
						</div>
					</div>

					<!-- Add new entry form -->
					<div class="display-flex flex-direction-column mt-4 pt-3 border-top-1">
						<h4 class="mb-3">{{ 'txQuickAccess.addNew' | translate }}</h4>
					<div class="mat-dense-input display-flex flex-grow-1 mb-2">
						<mat-form-field appearance="outline" class="flex-grow-1">
							<mat-label>{{ 'txQuickAccess.label' | translate }}</mat-label>
							<input matInput [(ngModel)]="NewBezeichnung" placeholder="{{ 'txQuickAccess.namePlaceholder' | translate }}" maxlength="25" />
						</mat-form-field>
					</div>
						<div class="display-flex mb-2">
							<mat-form-field appearance="outline" class="flex-grow-1 mr-1">
								<mat-label>{{ 'txQuickAccess.order' | translate }}</mat-label>
								<mat-select [(ngModel)]="NewAuftragsnummer" (selectionChange)="onNewAuftragChange()">
									<mat-option>
										<ngx-mat-select-search 
											[formControl]="searchControlAuftragNew" 
											(keyup)="onSearchAuftragNew($event)"
											[placeholderLabel]="'general.search' | translate"
											[noEntriesFoundLabel]="'general.noOptionsFound' | translate">
										</ngx-mat-select-search>
									</mat-option>
									<mat-option *ngFor="let auftrag of filteredAuftragsArrayNew" [value]="auftrag.auftragsnummer">
										{{ auftrag.bezeichnung }} ({{ auftrag.auftragsnummer }})
									</mat-option>
								</mat-select>
							</mat-form-field>
							<mat-form-field appearance="outline" class="flex-grow-1 mr-2">
								<mat-label>{{ 'txQuickAccess.task' | translate }}</mat-label>
								<mat-select [(ngModel)]="NewSchrittnummer" [disabled]="!NewAuftragsnummer">
									<mat-option>
										<ngx-mat-select-search 
											[formControl]="searchControlSchrittNew"
											(keyup)="onSearchSchrittNew($event)"
											[placeholderLabel]="'general.search' | translate"
											[noEntriesFoundLabel]="'general.noOptionsFound' | translate">
										</ngx-mat-select-search>
									</mat-option>
									<mat-option *ngFor="let schritt of getFilteredSchritteForNew()" [value]="schritt.schrittnummer">
										{{ schritt.schrittbezeichnung }}
									</mat-option>
								</mat-select>
							</mat-form-field>
							<div class="add-button-container">
								<button
									mat-mini-fab
									color="primary"
									(click)="onAddEntry(data.entries)"
									[disabled]="!canAdd(data.entries)">
									<fa-icon icon="plus"></fa-icon>
								</button>
							</div>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</ng-container>
